import React from 'react';
import PropTypes from 'prop-types';
import styles from './TabPanelReview.css';

const TabPanelReview = ({ title, subtitle, typeStyle, agents }) => {
  return (
    <div>
      <div className={styles.reviewSectionTitle}>
        <p className={styles.reviewInfoLabel}>{title}</p>
        <p>{subtitle}</p>
      </div>
      {agents.agents.map((item) => (
        <div
          key={item.agentName}
          className={`${styles.reviewSectionContent} ${typeStyle}`}
        >
          <div className={styles.reviewInfoGrid}>
            <div className={styles.reviewInfoItem}>
              <span>
                <span className={styles.reviewInfoLabel}>{item.agentName}</span>
                <span className={styles.reviewInfoItemSkill}>
                  {item.agentVersion}
                </span>
                <span className={styles.reviewInfoType}>{item.agentType}</span>
              </span>
              <span className={styles.reviewInfoTarget}>{item.target}</span>
              <span>{item.agentDescription}</span>
            </div>
            <div className={styles.reviewInfoItem}>
              <div className={styles.reviewInfoItemDetails}>
                <div className={styles.reviewInfoGrid}>
                  <div className={styles.reviewInfoItem}>Platform</div>
                  <div className={styles.reviewInfoItem}>{item.platform}</div>
                </div>
                <div className={styles.reviewInfoGrid}>
                  <div className={styles.reviewInfoItem}>Foundation model</div>
                  <div className={styles.reviewInfoItem}>{item.foundation}</div>
                </div>
                <div className={styles.reviewInfoGrid}>
                  <div className={styles.reviewInfoItem}>Agent ID</div>
                  <div className={styles.reviewInfoItem}>{item.agentId}</div>
                </div>
                <div className={styles.reviewInfoGrid}>
                  <div className={styles.reviewInfoItem}>Status</div>
                  <div className={styles.reviewInfoItem}>{item.status}</div>
                </div>
                <div className={styles.reviewInfoGrid}>
                  <div className={styles.reviewInfoItem}>Skills</div>
                  <div>
                    {item.skills.map((skillItem) => (
                      <span
                        key={skillItem.name}
                        className={styles.reviewInfoItemSkill}
                      >
                        {skillItem.name}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

TabPanelReview.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  typeStyle: PropTypes.string.isRequired,
  agents: PropTypes.shape({
    agents: PropTypes.shape([
      {
        agentName: PropTypes.string.isRequired,
        agentVersion: PropTypes.string.isRequired,
        agentType: PropTypes.string.isRequired,
        target: PropTypes.string.isRequired,
        agentDescription: PropTypes.string.isRequired,
        platform: PropTypes.string.isRequired,
        foundation: PropTypes.string.isRequired,
        agentId: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        skills: PropTypes.array.isRequired
      }
    ])
  })
};

export default TabPanelReview;
